module.exports = {"pathContext":{"name":"LocationOrLocationTag","kind":"UNION","type":"OBJECT","fields":null,"description":null,"enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"Location","ofType":null},{"kind":"OBJECT","name":"LocationTag","ofType":null}]}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/union-location-or-location-tag.json
// module id = 2142
// module chunks = 146958353494356